"use strict";

const demoConfig = {
  NAME: "AAUTI SOCIAL CORE DEMO",
  ENV: "demo",
  SOCIAL_API_URL: "YOUR_SOCIAL_API_URL",
  SOCIAL_TENANT_ID: "YOUR_SOCIAL_TENANT_ID"
};
export default demoConfig;
//# sourceMappingURL=demo.js.map